import React from "react";

import { getPushList } from "../../services/memberServices";

import AlarmList from "../../components/AlarmList";

type Props = {};

export default function Alarm(props: Props) {
  return <AlarmList icon={AlarmHelpIcon} getListApi={getPushList} />;
}

export const AlarmHelpIcon = (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="1"
      width="39"
      height="39"
      rx="3.5"
      fill="white"
      stroke="#CFCFCF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.749 29.2603L31.749 9.08398L7.74902 9.08398L7.74902 29.2603L16.3435 29.2603L19.749 33.084L23.1567 29.2603L31.749 29.2603Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M24.7208 19.1533C24.7208 21.5325 22.4947 23.4613 19.7488 23.4613C17.0029 23.4613 14.7769 21.5325 14.7769 19.1533"
      stroke="url(#paint0_linear_5294_23218)"
      strokeWidth="1.5"
    />
    <path
      d="M24.7095 15.2168L24.7219 15.2168"
      stroke="url(#paint1_linear_5294_23218)"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M14.7769 15.2168L14.7892 15.2168"
      stroke="url(#paint2_linear_5294_23218)"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5294_23218"
        x1="14.7769"
        y1="22.0922"
        x2="22.4167"
        y2="20.2435"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="0.992254" stopColor="#E100A3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5294_23218"
        x1="24.7095"
        y1="15.899"
        x2="24.7195"
        y2="15.899"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="0.992254" stopColor="#E100A3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5294_23218"
        x1="14.7769"
        y1="15.899"
        x2="14.7869"
        y2="15.899"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA27C2" />
        <stop offset="0.992254" stopColor="#E100A3" />
      </linearGradient>
    </defs>
  </svg>
);
